import * as actions from './updateAddressActions';
import { capitalize } from '../../../lib/helpers';

const updateAddressReducers = {
  [actions.USER_UPDATE_ADDRESS_SUCCESS_RECEIVED]: (state, { payload }) => {
    state.addresses['mailing'] = {
      ...payload,
      streetAddress: capitalize(payload.streetAddress),
      addressLine2: capitalize(payload.addressLine2),
      city: capitalize(payload.city),
    };
    return state;
  },
  [actions.UPDATE_VERSION_ID]: (state, { payload }) => {
    state.addresses['mailing'] = {
      ...state.addresses['mailing'],
      versionId: payload.versionId,
    };
    return state;
  },
};

export default updateAddressReducers;
